var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlitz({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "blitz-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svg blitz",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "blitz") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.47,31.84,14.09,30.7a2.3,2.3,0,0,1-1.71,0,2.64,2.64,0,0,1-1.72-2.52v-.35L11.92,23,9.63,24.74l-7.1-3A4,4,0,0,1,0,18.21a4.09,4.09,0,0,1,2.06-3.77L25.89.7a4,4,0,0,1,4.35.22,4.18,4.18,0,0,1,1.72,4L28.18,27.26A3.86,3.86,0,0,1,26.12,30a4,4,0,0,1-3.21.34h-.34l-.23-.23L18.1,28.41Zm-1.6-5,1.14.92,2.4-2.86,6.42,2.74a1,1,0,0,0,1-.11,1,1,0,0,0,.57-.92l3.78-22.1a1.67,1.67,0,0,0-.46-1.26,1.28,1.28,0,0,0-1.37-.11L3.56,16.84a1.39,1.39,0,0,0-.69,1.26,1.1,1.1,0,0,0,.8,1l5.5,2.29,7.9-6.87L13.75,27.26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlitz);
export default __webpack_public_path__ + "static/media/blitz.4eb28bfeebce570b6bf27648599ffea6.svg";
export { ForwardRef as ReactComponent };